import EmptyRecord from './EmptyRecord';

export default EmptyRecord;
